import React, { memo } from 'react';
import {
  ToolbarCheckCircleIcons,
  ToolbarClearIcons,
  ToolbarListIcons,
  ToolbarSearchIcons,
} from '../../../../../../icons/icons';
import { CandidateStatusLegend } from '../CandidateStatusLegend';
import { ExpandableSearchSectionProps } from './interfaces';
import { UnsuccessfulApplicantsActions } from './UnsuccessfulApplicantsActions';

export const ExpandableSearchSection = memo<ExpandableSearchSectionProps>(
  ({
    isToolbarExpanded,
    globalSearchTerm,
    setGlobalSearchTerm,
    clearSearchTerm,
    hasSearchResults,
    filteredCandidateCount,
    handleSearchPanelToggle,
    isSearchPanelShow,
    candidateCount,
    isUnsuccessfulTab,
    selectAllUnsuccessful,
    handleClearSelected,
    isClearDisabled,
    handleSendEmailToSelected,
    isSendEmailDisabled,
    selectedApplicantCount,
    candidates,
  }) => (
    <div
        className={`overflow-hidden transition-all duration-500 ease-in-out ${
          isToolbarExpanded ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'
        }`}
        aria-hidden={!isToolbarExpanded}
    >
      <div className='px-3 sm:px-4 pb-2 flex items-center gap-2'>
        <div className='relative max-w-2xl flex-1'>
          <input
              type='text'
              placeholder='Search by name or email...'
              value={globalSearchTerm}
              onChange={(e) => setGlobalSearchTerm(e.target.value)}
              className='w-full h-8 sm:h-9 px-3 pl-9 sm:pl-10 pr-10 sm:pr-12 text-sm border border-slate-200 rounded-lg focus:ring-2 focus:ring-emerald-500/50 focus:border-emerald-400 bg-white/80 backdrop-blur-sm shadow-sm transition-all duration-200 placeholder:text-slate-400 hover:shadow-md focus:shadow-lg'
              aria-label='Search candidates by name or email'
          />

          <div className='absolute inset-y-0 left-0 pl-3 sm:pl-4 flex items-center pointer-events-none'>
            <ToolbarSearchIcons className='h-4 sm:h-5 w-4 sm:w-5 text-emerald-500' />
          </div>

          { globalSearchTerm && (
            <div className='absolute inset-y-0 right-0 flex items-center pr-2'>
              { hasSearchResults && (
                <button
                    onClick={handleSearchPanelToggle}
                    className={`mr-1 p-2 rounded-lg transition-all duration-200 ${
                      isSearchPanelShow
                        ? 'bg-emerald-100 text-emerald-700 shadow-sm'
                        : 'text-slate-400 hover:text-emerald-600 hover:bg-emerald-50/80'
                    }`}
                    title={
                      isSearchPanelShow
                        ? 'Hide results panel'
                        : 'Show results panel'
                    }
                    aria-label={
                      isSearchPanelShow
                        ? 'Hide results panel'
                        : 'Show results panel'
                    }
                    aria-pressed={isSearchPanelShow}
                >
                  <ToolbarListIcons className='w-3 sm:w-4 h-3 sm:h-4' />
                </button>
              ) }

              <button
                  onClick={clearSearchTerm}
                  className='p-2 rounded-lg text-slate-400 hover:text-red-500 hover:bg-red-50/80 transition-all duration-200'
                  title='Clear search'
                  aria-label='Clear search'
              >
                <ToolbarClearIcons className='h-3 sm:h-4 w-3 sm:w-4' />
              </button>
            </div>
          ) }
        </div>{ ' ' }
        { /* Search Results Info */ }
        { globalSearchTerm && (
          <div className=' flex justify-center'>
            <div
                className={`inline-flex items-center gap-2 backdrop-blur-sm px-3 sm:px-4 py-2 rounded-full text-xs font-medium border shadow-sm ${
                  filteredCandidateCount > 0
                    ? 'bg-emerald-50/80 text-emerald-700 border-emerald-200/60'
                    : 'bg-red-50/80 text-red-700 border-red-200/60'
                }`}
                role='status'
                aria-live='polite'
            >
              <ToolbarCheckCircleIcons className='w-3 h-3' />
              { filteredCandidateCount > 0
                ? `${filteredCandidateCount} of ${candidateCount} found`
                : 'No results found' }
            </div>
          </div>
        ) }
        { isUnsuccessfulTab && (
          <UnsuccessfulApplicantsActions
              selectAllUnsuccessful={selectAllUnsuccessful}
              handleClearSelected={handleClearSelected}
              isClearDisabled={isClearDisabled}
              handleSendEmailToSelected={handleSendEmailToSelected}
              isSendEmailDisabled={isSendEmailDisabled}
              selectedApplicantCount={selectedApplicantCount}
          />
        ) }
      </div>
      <CandidateStatusLegend candidates={candidates} />
    </div>
  ),
);

ExpandableSearchSection.displayName = 'ExpandableSearchSection';
